import * as Lazy from './blogRoutes.lazy';

const blogRoutes = [
  {
    public: true,
    path: '/blog',
    renderer: props => <Lazy.BlogHub {...props} />
  },
  {
    public: true,
    path: '/blog/what-is-fairline',
    renderer: props => <Lazy.WhatIsFairLine {...props} />
  },
];

export default blogRoutes;
